module.exports = __webpack_public_path__ + "omlazeni-pleti_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/laserova-estetika/omlazeni-pleti_2_after_tn.jpg
// module id = 1483
// module chunks = 0